import { render, staticRenderFns } from "./JobCardSlide.vue?vue&type=template&id=378e2e4d&scoped=true&"
import script from "./JobCardSlide.vue?vue&type=script&lang=js&"
export * from "./JobCardSlide.vue?vue&type=script&lang=js&"
import style0 from "./JobCardSlide.vue?vue&type=style&index=0&id=378e2e4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378e2e4d",
  null
  
)

export default component.exports